import { render, staticRenderFns } from "./DowngradeDialog.vue?vue&type=template&id=7d53c109&scoped=true&"
import script from "./DowngradeDialog.vue?vue&type=script&lang=js&"
export * from "./DowngradeDialog.vue?vue&type=script&lang=js&"
import style0 from "./DowngradeDialog.vue?vue&type=style&index=0&id=7d53c109&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d53c109",
  null
  
)

export default component.exports